import { Tag } from '@blueprintjs/core';

export function PaymentRemarkTag({
  numberOfRemarks,
}: {
  numberOfRemarks: number | string | undefined;
}) {
  switch (numberOfRemarks) {
    case undefined:
      return (
        <Tag minimal round intent="warning">
          Unknown
        </Tag>
      );
    case 0:
      return (
        <Tag minimal round intent="success">
          No remarks
        </Tag>
      );
    default:
      return (
        <Tag minimal round intent="danger">{`Remarks: ${numberOfRemarks}`}</Tag>
      );
  }
}
